<template>
  <div id="app">
    
    <router-view></router-view>
    <Toast />
    <Globaldialog />
  </div>
</template>
<style lang="less">
  
</style>
<script>
import Toast from '@/components/common/toast.vue';
import Globaldialog from './components/common/globaldialog.vue';
export default {
  name: 'App',
  inject:['$toast'],
  data () {
    return {
      
    }
    
  },
  components:{
      Toast,
      Globaldialog
  }
}
</script>
<style lang="less">
  #app{
    font-family: Helvetica, Arial, Helvetica, sans-serif;
  }
  
</style>